<template>
	<div class="addPolicy">
		<div class="addPolicyCon">
			<div class="fill" v-loading="loading">
				<div class="title">
					<!-- <img src="@/static/sort.png" class="icon" /> -->
					<div>
						添加政策
					</div>
				</div>
				<div class="form">
					<el-form :model="ruleForm" ref="ruleForm" :rules="rules" :inline='true' label-width="100px" label-position='top'>
						<div class="flexbox">
							<el-form-item label="政策标题" prop="title" class="box">
								<el-input v-model="ruleForm.title" placeholder="请输入政策标题" style="width: 100%;"></el-input>
							</el-form-item>
							<el-form-item label="报名人数" prop="application_limit" class="box">
								<el-input v-model="ruleForm.application_limit" type="number" placeholder="请输入报名人数,输入0即表示不限" style="width: 100%;"></el-input>
							</el-form-item>
							<el-form-item label="申报时间" prop="time" class="box">
								<el-date-picker 
									v-model="ruleForm.time" 
									type="daterange" 
									format="yyyy-MM-dd" 
									value-format="yyyy-MM-dd" 
									range-separator="至"
									start-placeholder="开始日期" 
									end-placeholder="结束日期"  
									style="width: 100%;">
								</el-date-picker>
							</el-form-item>
						</div>
						
						<div class="flexbox">
							<el-form-item label="政策分类" prop="class_id" class="box">
								<el-cascader 
									v-model="ruleForm.class_id"
									:options="classList" 
									filterable 
									:props="classProps" 
									style="width: 100%;" >
								</el-cascader>
							</el-form-item>
							<el-form-item label="所属行业" prop="industry_id" class="box">
								<el-select v-model="ruleForm.industry_id" filterable placeholder="请选择" style="width: 100%;">
								    <el-option
								      v-for="item in industryList"
								      :key="item.id"
								      :label="item.industry_name"
								      :value="item.id">
								    </el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="发布日期" prop="issuance_date" class="box">
								<el-date-picker
									style="width: 100%;"
								    v-model="ruleForm.issuance_date"
								    type="date"
									format="yyyy-MM-dd" 
									value-format="yyyy-MM-dd"
								    placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
						</div>
						
						<div class="flexbox">
							<el-form-item label="封面图" prop="cover_file">
								<div class="uploadbox">
									<div class="imgbox" v-if="ruleForm.cover_file">
										<el-image class="img" :src="createFileUrl(ruleForm.cover_file)" fit="cover"></el-image>
										<i class="el-icon-error delIcon" @click="ruleForm.cover_file=''"></i>
									</div>
									<div class="imgbox upload" v-else @click="$refs.uploadImg.click()">
										<input class="input" id="uploadImg" ref="uploadImg" accept="image/*" type="file" @change="uploadimg"/>
										<i class="el-icon-upload icon"></i>
										<div class="text">点击上传封面图</div>
									</div>
								</div>
							</el-form-item>
						</div>
						
						
						<div class="flexbox">
							<el-form-item label="政策简述" prop="description">
								<el-input type="textarea" style="width: 1114px;" :autosize="{ minRows: 6, maxRows: 12}"
									placeholder="请简略描述政策" v-model="ruleForm.description"></el-input>
							</el-form-item>
						</div>
						
						<div class="flexbox">
							<el-form-item label="政策全文" prop="text_content">
								<el-input type="textarea" style="width: 1114px;" :autosize="{ minRows: 8, maxRows: 16}"
									placeholder="请输入政策内容" v-model="ruleForm.text_content"></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>

				<div class="buttonG">
					<el-button type="primary" plain @click="backGo">返回</el-button>
					<el-button type="primary" class="save" @click="submit()">申请发布</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addPolicy',
		data() {
			var checkClass = (rule, value, callback) => {
			    console.log(value)
			};
			return {
				loading:false,
				ruleForm: {
					title:'',
					application_limit:'',
					issuance_date:'',
					cover_file:'',
					description:'',
					text_content:'',
					industry_id:'',
					class_id:[],
					time:[]
				},
				rules:{
					title:[{ required: true, message: '请输入政策标题', trigger: 'blur' }],
					application_limit:[{ required: true, message: '请输入报名人数', trigger: 'blur' }],
					issuance_date:[{ required: true, message: '请选择发布日期', trigger: 'change' }],
					cover_file:[{ required: true, message: '请上传封面图', trigger: 'change' }],
					time:[{ required: true, message: '请选择报名时间', trigger: 'change' }],
					description:[{ required: true, message: '请输入政策简述', trigger: 'blur' }],
					text_content:[{ required: true, message: '请输入政策内容', trigger: 'blur' }],
					industry_id:[{ required: true, message: '请选择所属行业', trigger: 'change' }],
					class_id:[{ required: true, message: '请选择政策分类', trigger: 'change' }],
				},
				classList:[],
				industryList:[],
				classProps:{
					value: 'id',
					label: 'title',
					children: 'child',
					expandTrigger:'hover'
				},
			}
		},
		created() {
			this.getClassList()
			this.getIndustryList()
		},
		methods: {
			createFileUrl(file){
				const windowURL = window.URL || window.webkitURL;
				return windowURL.createObjectURL(file)
			},
			uploadimg(e){
				let imgsFiles = e.target.files[0]
				if(!imgsFiles.type.startsWith('image/')) return this.$eltips('仅支持图片格式','error'),this.$refs['uploadImg'].value = '';
				this.ruleForm.cover_file = imgsFiles;
				this.$refs['uploadImg'].value = '';
			},
			//行业分类
			getIndustryList(){
				this.$axios.get('/api/client/Common/getIndustrys').then(res => {
					this.industryList = res.data
				})
			},
			//政策分类
			getClassList(){
				this.$axios.get('/api/client/Policy/getClassification').then(res => {
					this.classList = res.data
				})
			},
			backGo(){
				this.$router.go(-1)
			},
			submit(){
				this.$refs.ruleForm.validate(async (valid) => {
				    if (valid){
						this.loading = true
						let data=this.ruleForm
						data.application_start_date=data.time[0]
						data.application_end_date=data.time[1]
						data.first_class_id = data.class_id[0]
						data.second_class_id = data.class_id[1]
						delete data.time
						delete data.class_id
						let tokenRes = await this.$axios.get('/api/client/Common/getQiniuToken')
						if(tokenRes.code!=200) return this.loading = false,this.$eltips('上传封面图失败,请稍后再试','warning');
						const keys = 'en-user-policy-'+  this.$util.getStorage('userinfo').id +'-'+ new Date().getTime()
						const qiniuUrl = await this.$util.qiniuUpload(data.cover_file,keys,tokenRes.data)
						if(!qiniuUrl) return this.loading = false,this.$util.tips('上传封面图失败，请稍后重试');
						data.cover_image = qiniuUrl
						delete data.cover_file
						this.$axios.post('/api/client/ES/createPolicys',data).then(res => {
							this.loading = false
							if (res.code == 200) {
								this.$eltips(res.msg)
								this.$router.go(-1)
							} else {
								this.$eltips(res.msg, 'error')
							}
						})
					}else{
						this.$nextTick(()=>{
							document.getElementsByClassName("is-error")[0].scrollIntoView({
								behavior: "smooth",
								block: "center"
							});
						})
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.addPolicy {
		position: relative;
		padding: 24px 0;
		min-height: 801px;
		box-sizing: border-box;
		.addPolicyCon {
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.fill {
				padding: 33px 43px 38px;
				background-color: #fff;
				border-radius: 16px;
				.title {
					display: flex;
					align-items: center;
					color: #151515;
					font-size: 22px;
					font-weight: bold;
					margin-bottom: 35px;

					.icon {
						width: 39px;
						height: 39px;
						margin-right: 13px;
					}
				}

				.form {
					// padding-left: 52px;
					.flexbox{
						display: flex;
						.box{
							flex: 1;
							margin-right: 48px;
							&:last-child{
								margin-right: 0;
							}
						}
					}
					.uploadbox{
						.imgbox{
							width: 300px;
							height: 230px;
							position: relative;
							.img{
								width: 100%;
								height: 100%;
							}
							.delIcon{
								position: absolute;
								right: -7px;
								top: -7px;
								font-size: 18px;
							}
							.input{
								width: 0;
								height: 0;
								opacity: 0;
							}
						}
						.upload{
							cursor: pointer;
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							border: 1px dashed #ccc;
							position: relative;
							overflow: hidden;
							.text{
								font-size: 15px;
								color: #999;
							}
							.icon{
								color: #999;
								font-size: 38px;
							}
							&:hover{
								border-color: #51A190;
								.text,.icon{
									color: #51A190;
								}
							}
						}
					}
				}

				.buttonG {
					display: flex;
					align-items: center;
					justify-content: flex-end;

					.el-button {
						font-size: 16px;
						border-radius: 16px;
						height: 56px;
						width: 120px;
					}

					.save {
						width: 190px;
					}
				}
			}
		}
	}
</style>

